import server from "@/src/api/server";
import { checkRedirect } from "@/src/components/helpers/functions";
import styles from "@/styles/contact.module.scss";
import { useRouter } from "next/router";
import { useIntl } from "react-intl";

import BreadCrumb from "@/src/components/Shared/BreadCrumbs";
import Seo from "@/src/components/Shared/Next-seo";
import RequestForm from "@/src/components/Home/request";

export default function Request({ requestData, seoData }) {
  const { formatMessage, locale } = useIntl();
  const { query } = useRouter();

  return (
    <>
      {seoData?.title?.[locale] && (
        <Seo
          title={seoData?.title?.[locale]}
          description={seoData?.description?.[locale]}
          keywords={seoData?.keywords?.[locale]}
         
        />
      )}
      <div className={`contact-page ${styles.contact}`}>
        <BreadCrumb
          heading={formatMessage({
            id: query?.personId ? "request" : "admissionRequest",
          })}
          description={`${formatMessage({
            id: "main",
          })} / ${formatMessage({
            id: "request",
          })}`}
          background={requestData?.breadCurmbImage}
        />
        <div className="wrapper">
          <RequestForm countries={requestData?.items} />
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps(ctx) {
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  const [homeResponse, countriesResponse, seoPageResponse] = await Promise.all([
    server.get("/pages/home"),
    server.get("/countries"),
    server.get("/pages/seo-data"),
  ]);

  const sectionData = (r) => r?.data?.data?.page?.sections || [];

  const seoData = sectionData(seoPageResponse)?.find(
    (section) => section?.pageName === "request",
  );

  const homeData = (section) =>
    sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];

  return {
    props: {
      requestData: {
        breadCurmbImage: homeData("intro")?.items[0]?.backgroundImage,
        items: countriesResponse?.data?.data?.countries,
      },
      seoData,
    },
  };
}
